// 认证系统
export const AUTH = 'AUTH'
export const INDEPENDENT = 'INDEPENDENT'

// 框架模块
export const APPS = 'APPS'

// 巡检模块
// 日常巡检
export const DAILYINSPECTION = 'DAILYINSPECTION'
// 装修巡检
export const RENOVATIONINSPECTION = 'RENOVATIONINSPECTION'

// 工单模块
// 工单流程
export const WORKFLOW = 'WORKFLOW'
// 工单模板
export const WORKTEMPLATE = 'WORKTEMPLATE'

// 申请模块
// 工单申请
export const BILLREQUEST = 'BILLREQUEST'
// 待审批工单
export const BILLPENDING = 'BILLPENDING'
// 已审批工单
export const BILLALREADY = 'BILLALREADY'
// 已发起工单
export const BILLSPONSOR = 'BILLSPONSOR'
// 收到抄送工单
export const BILLCOPY = 'BILLCOPY'
// 所有工单
export const BILLALL = 'BILLALL'

// 资料下载
export const MATERIALDOWNLOAD = 'MATERIALDOWNLOAD'

// 消息模板
export const NEWSTEMPLATE = 'NEWSTEMPLATE'
// 消息发送
export const NEWSSEND = 'NEWSSEND'
// 消息接收
export const NEWSACCEPT = 'NEWSACCEPT'
